import { render, staticRenderFns } from "./exhibitionInfo.vue?vue&type=template&id=12f1ec49&scoped=true"
import script from "./exhibitionInfo.vue?vue&type=script&lang=js"
export * from "./exhibitionInfo.vue?vue&type=script&lang=js"
import style0 from "./exhibitionInfo.vue?vue&type=style&index=0&id=12f1ec49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f1ec49",
  null
  
)

export default component.exports